import { UserService } from "@tytapp/user";
import { Injectable } from "@angular/core";
import { LocalStorageService } from "@tytapp/common";
import { ApiUser } from "@tytapp/api";
import { v4 as uuid } from 'uuid';
import { isClientSide } from '@tytapp/environment-utils';

export interface CartItem<T> {
    uuid: string;
    type: string;
    data: T;
}

export interface Purchaser {
    email: string;
}

@Injectable()
export class CartService {
    constructor(
        private users: UserService,
        private localStorage: LocalStorageService
    ) {
        let markReady;
        this._readyPromise = new Promise((res, rej) => markReady = res)
        this.users.userChanged.subscribe(user => {
            this.user = user;
            this.invalidateOnUserChange();
            this.loadCart();
            markReady();
        })
    }

    private user: ApiUser;
    private _items: CartItem<any>[] = [];
    private _purchaser: Purchaser;
    private _readyPromise : Promise<void>;

    get ready() {
        return this._readyPromise;
    }

    get purchaser() {
        return Object.assign({}, this._purchaser);
    }

    get items() {
        return this._items;
        //return this._items.map(x => Object.assign({}, x));
    }

    get cartLength() {
        return this._items.length;
    }

    get currentCartStatus() {
        if (this._items.length === 0) {
            return 'empty';
        }
        if (this._items[0].type === 'gift') {
            return 'gift';
        }
        if (this._items[0].type === 'sponsorship') {
            return 'sponsorship';
        }
    }

    newItem<T>(type : string, data? : Partial<T>): CartItem<T> {
        return {
            uuid: uuid.v4(),
            type: type,
            data: (data || {}) as any
        }
    }

    loadCart() {
        if (isClientSide()) {
            this._items = this.localStorage.get('cart') || [];
            this._purchaser = this.localStorage.get('purchaser');
        } else {
            this._items = [];
            this._purchaser = undefined;
        }
    }

    removeFromCart(item: CartItem<any>) {
        this._items = this._items.filter(x => x.uuid != item.uuid);
        this.saveCart();
    }

    updateItemInCart(item: CartItem<any>) {
        let found = false;
        this._items = this._items.map(x => {
            if (x.uuid == item.uuid) {
                found = true;
                return item;
            }

            return x;
        });

        if (!found)
            this._items.push(item);

        this.saveCart();
    }

    setPurchaser(purchaser: Purchaser) {
        this._purchaser = purchaser;
        this.savePurchaser();
    }

    savePurchaser() {
        this.localStorage.set('purchaser', this._purchaser);
    }

    clearCart() {
        this._items = [];
        this._purchaser = null;

        this.localStorage.set('cart', []);
        this.localStorage.set('purchaser', {});
        this.localStorage.set('purchasingUserID', '');

        this.localStorage.remove('purchaser');
        this.localStorage.remove('purchasingUserID');
    }

    invalidateOnUserChange() {
        let purchasingUserID = this.localStorage.get('purchasingUserID');
        if (this.user) {
            if (purchasingUserID && this.user.uuid != purchasingUserID) {
                this.clearCart();
            }
        } else {
            if (purchasingUserID) {
                this.clearCart();
            }
        }
    }

    saveCart() {
        if (this.user)
            this.localStorage.set('purchasingUserID', this.user.uuid);
        else
            this.localStorage.remove('purchasingUserID');

        this.localStorage.remove('cart');
        this.localStorage.set('cart', this._items);
    }


}